import { Component, Inject, OnInit, inject, DestroyRef } from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import { animate, style, transition, trigger, query, sequence, stagger, state } from '@angular/animations';
import { combineLatest } from 'rxjs';
import { TenantService } from 'src/app/services/api/tenant.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SubscriptionTypes } from 'src/app/models/subscription.model';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { translate } from '@jsverse/transloco';

@Component({
    selector: 'app-workflow-diagram',
    templateUrl: './workflow-diagram.component.html',
    styleUrls: ['./workflow-diagram.component.scss'],
    animations: [
        trigger('animation', [
            transition('void => *', [
                query('.level-2-wrapper', [
                    style({ opacity: 0, transform: 'translateY(-100px)' }),
                    stagger(400, [
                        animate('0.40s .40s ease-in', style({ opacity: 1, transform: 'translateY(0)' }))
                    ])
                ]),
                query('.level-3-wrapper', [
                    style({ opacity: 0, transform: 'translateY(-100px)' }),
                    stagger(0, [
                        animate('0.40s .40s ease-in', style({ opacity: 1, transform: 'translateY(0)' }))
                    ])
                ], { optional: true }),
                query('.level-1', [
                    style({ opacity: 1, transform: 'translateY(0px)' }),
                    stagger(3000, [
                        animate('0.25s .4s ease-in', style({ opacity: 1, transform: 'translateY(0)' }))
                    ])
                ]),
            ])
        ])
    ],
    standalone: false
})
export class WorkflowDiagramComponent  implements OnInit {
private destroyRef = inject(DestroyRef);
  isLoading = true;
  tenantDetails: any;
  dataWorkflow: any;
  selectedTenant: any;
  animationStart = false;
  workflowDetails = {
    azure: { pii: false, nonPii: false },
    aws: { prodPii: false, nonPii: false, nonProdPii: false}
  };

  constructor(@Inject(MAT_DIALOG_DATA) private data: any,
  private tenantService: TenantService, private dialog: MatDialog) {  }

  ngOnInit(): void {
    this.selectedTenant = this.data.selectedTenant;
    combineLatest([this.tenantService.getTenantAccountDetails(this.selectedTenant.tenantId),
      this.tenantService.getTenantDetails(this.selectedTenant.tenantId)])
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(([workflow, tenantDetails])=> {
      this.tenantDetails = tenantDetails;
      this.dataWorkflow = workflow;
      this.animationStart = true;
      this.dataWorkflow.forEach(element => {
        if(element.azureDetails?.subscriptionId && element.dataZone === SubscriptionTypes.PII) {
          this.workflowDetails.azure.pii = true;
        }
        if(element.azureDetails?.subscriptionId && element.dataZone === SubscriptionTypes.TEST) {
          this.workflowDetails.azure.nonPii = true;
        }
        if(element.awsDetails?.accountId && element.dataZone === SubscriptionTypes.PROD_PII) {
          this.workflowDetails.aws.prodPii = true;
        }
        if(element.awsDetails?.accountId && element.dataZone === SubscriptionTypes.AWS_NON_PII) {
          this.workflowDetails.aws.nonPii = true;
        }
        if(element.awsDetails?.accountId && element.dataZone === SubscriptionTypes.AWS_NONPROD_PII) {
          this.workflowDetails.aws.nonProdPii = true;
        }
      });
      this.isLoading = false;
    },
    (error) => {
      this.dialog.closeAll();
      this.isLoading = false;
      const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
      this.dialog.open(ErrorDialogComponent, {
        minHeight: '342px',
        width: '630px',
        panelClass: 'flex-dialog',
        data: {
          title:  translate('ERROR_DIALOG.CREATION_WORKFLOW_NOT_AVAILABLE'),
          description: errorMessage
        }
      });
    });
  }

}
